var map = {
	"./de/gotoTOPbg.png": "6i5A",
	"./en/gotoTOPbg.png": "CsFg",
	"./es/gotoTOPbg.png": "9YaA",
	"./fr/gotoTOPbg.png": "cLb1",
	"./ja/gotoTOPbg.png": "JbXo",
	"./ko/gotoTOPbg.png": "KEGj",
	"./pt/gotoTOPbg.png": "O91R",
	"./ru/gotoTOPbg.png": "R+w7",
	"./tc/gotoTOPbg.png": "HXMG",
	"./th/gotoTOPbg.png": "UTPZ"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "LhpQ";